import React from "react";
import { Typography } from "@mui/material";

const SectionTitle = ({ children }) => (
  <Typography
    data-testid="theme-section-title"
    sx={{
      fontWeight: "bold",
      fontSize: "14px",
      mb: "8px",
      fontFamily: "DM Sans",
      color: "#0F0F0F",
    }}
  >
    {children}
  </Typography>
);

export default SectionTitle;
